import { OrderProfanityCheckStatus } from "@/types/order"
import axios from "./orderInstance"
import { toast } from "react-toastify"
export default async (orderId: string) => {
  const payload = {
    operation: "mark_as_done",
    values: {
       
    }
  };

  try {
    const response: any = await axios.patch(`/orders/${orderId}`, payload);
    toast.success('Order changed successfully');
    return response.data
  } catch (error) {
    return null
  }
}
